export default "__VITE_ASSET__wFFiyu5d__"